export default function () {
  const widgetName = 'cardWidget';
  const widgetOpts = cardWidgetOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function (data, owl, hasData) {
      $(`#${widgetName} .card-widget-item`).each(function (x) {
        let windowSize = $(window).width();

        let newDescription = data.items[x].Description;
        let newUrl = data.items[x].URL == null ? "" : `<a href="${data.items[x].URL}" class="button">More</a>`; let newUrlMobile = data.items[x].URL == null ? "<div class='overlay-mobile'>" : `<a href="${data.items[x].URL}" class="overlay-mobile" title="Read More">`;

        let overlayStructure = `
            <div class="overlay-desktop">
                <div class="overlay-color">
                    <span class="card-description">${newDescription}</span>
                    ${newUrl}
                </div>
                <div class="border"></div>
            </div>`;

        if (windowSize <= 1120) {
          overlayStructure = `
                ${newUrlMobile}
                  <span class="card-description">${newDescription}</span>
                  <div class="border"></div>
                ${data.items[x].URL == null ? "</div>" : "</a>"}`;
        }


        $(this).find('.card-widget-description').remove();
        $(this).find('.buttonwrap').remove();
        $(this).find('.image-container').append(overlayStructure);
      })

    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: [''], 
    maxItemsVisible: 8,
    moreButton: {
      visible: true,
      text: 'More'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: false
  });

}